// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import util from './common/util.js'

// 引入组件
import vant from 'vant'
import 'vant/lib/index.css'
import wxapi from './common/wxShare'
import scrollManager from './common/scrollManager.js';
import { Lazyload } from 'vant';

// 注册 Service Worker（生产环境）
import { register } from './registerServiceWorker'
if (process.env.NODE_ENV === 'production') {
  register()
}

Vue.config.productionTip = false
Vue.use(vant)
Vue.prototype.$util = util
Vue.prototype.$scrollManager = scrollManager
// 必须注册 Lazyload
Vue.use(Lazyload);

wxapi.initWxConfig();

// //初始化广告SDK
// util.handler.tencentAdInitSdk();

// // 🔄 版本检测和自动刷新（生产环境）
// if (process.env.NODE_ENV === 'production') {
//   // 使用固定的版本号，而不是动态时间戳
//   const APP_VERSION = '1.0.0';  // 每次发布时手动更新版本号
//   const VERSION_KEY = 'app_version';
//   const savedVersion = localStorage.getItem(VERSION_KEY);
  
//   // 检测到新版本，清除缓存并刷新（只刷新一次）
//   if (savedVersion && savedVersion !== APP_VERSION) {
//     console.log('🔄 检测到新版本，正在更新...');
//     localStorage.setItem(VERSION_KEY, APP_VERSION);
//     // 添加刷新标记，防止循环刷新
//     const REFRESH_FLAG = 'app_refreshing';
//     if (!sessionStorage.getItem(REFRESH_FLAG)) {
//       sessionStorage.setItem(REFRESH_FLAG, 'true');
//       setTimeout(() => {
//         window.location.reload(true);
//       }, 500);
//     }
//   } else {
//     localStorage.setItem(VERSION_KEY, APP_VERSION);
//   }
  
//   // 定期检查更新（每5分钟）
//   setInterval(() => {
//     fetch('/wap/index.html?t=' + Date.now(), { 
//       method: 'HEAD', 
//       cache: 'no-cache' 
//     }).catch(() => {});
//   }, 5 * 60 * 1000);
// }

// 全局监听路由
router.beforeEach((to, from, next) => {

 if (from.name) {
  var previousRoute=from.fullPath;
    if(previousRoute !== "/loginIndex" &&
        previousRoute !== "/registerIndex")
    {
      localStorage.setItem('previousRoute', previousRoute);
    }
  }

  // // 保存当前页面的滚动位置
  // if (from.path) {
  //   // if(to.path.indexOf('/alreadyBmxx')>-1
  //   //   ||to.path.indexOf('/mdgsIndex')>-1
  //   //   ||to.path.indexOf('/cqgsIndex')>-1
  //   //   ||to.path.indexOf('/jmdIndex')>-1
  //   //   ||to.path.indexOf('/changeXmIndex')>-1
  //   //   ||to.path.indexOf('/changeXmIndex')>-1
  //   //   ||to.path.indexOf('/changeXmIndex')>-1){
  //       const fromRouteKey = from.fullPath;
  //       const scrollY = scrollManager.getCurrentScrollY();
  //       scrollManager.saveScrollPosition(fromRouteKey, scrollY);
  //     // }
  // }

  // alert(to.query.ssid)
 
  if(to.query.initpage==='Y'){
    localStorage.setItem("routeValue", "");
    var saveUrl=localStorage.getItem('saveUrl');
    
    var query=localStorage.getItem('query');
    if(saveUrl===undefined||saveUrl===null||saveUrl===''||saveUrl.indexOf('https://')>-1){}
    else{
      saveUrl=saveUrl.replace('https://www.ptty.com.cn/','http://wap.ptty.com.cn');
      if(saveUrl.indexOf('writeTeamRym')>-1
      ||saveUrl.indexOf('indexXywl')>-1
      ||saveUrl.indexOf('indexZtHpzg')>-1
      ||saveUrl.indexOf('indexSxJcty')>-1
      ||saveUrl.indexOf('indexXrxk')>-1
      ||saveUrl.indexOf('indexJfty')>-1
      ||saveUrl.indexOf('indexBrq')>-1
      ||saveUrl.indexOf('indexRcqqx')>-1
      ||saveUrl.indexOf('indexGxss')>-1
      ||saveUrl.indexOf('indexLjyx')>-1){
        router.push({
          path: '/'
        }); 
      }
      else{
        router.push({
          path: saveUrl,
          query: JSON.parse(query)
        }); 
      }
    }
  }
  else{
    var fullUrl=to.fullPath;
    if(fullUrl.indexOf('writeTeamRym')>-1){}
    else{
      localStorage.setItem('saveUrl',fullUrl);
      localStorage.setItem('query',JSON.stringify(to.query));
    }
  }
  // alert('00')
  next();
});

// 路由后置守卫 - 恢复滚动位置
router.afterEach((to, from) => {
  // 延迟执行，确保页面渲染完成
  setTimeout(() => {
    var ssid=to.query.ssid;
    if(ssid===undefined||ssid.length==0){
      ssid='';
    }
    wxapi.setShareTimeline(ssid,to.fullPath)
  }, 100);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js